module.exports = __webpack_public_path__ + "assets/img/free_5.178414bd.png";